<template>
  <div class="flex flex-wrap mb-2" :style="guideStep >= 45 && guideStep <= 49 ? { zIndex: 100, position: 'relative' } : null">
    <div class="w-full lg:w-3/4 flex-1 min-w-0 bg-white rounded-xl space-y-6 p-3 lg:p-6">
      <div>
        <span v-if="!editPageType" class="text-red-500">*</span>
        <span class="text-grap-700 align-middle" @click="testPAD">{{lang['components']['Event']['PositionAndDevice']['title']}}</span>
        <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip="'版位與裝置'"></i> -->
        <button
          v-if="false"
          id="positionAndDevice"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
          @click="teachVideo()"
        >
          {{lang['components']['Event']['PositionAndDevice']['video_teaching']}}
        </button>
      </div>
      <div class="flex-1 space-y-4">
        <!-- 新手教學 -->
        <div class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 46, 'cursor-not-allowed': editPageType === true }">
          <div class="flex">
            <input v-if="false" type="radio" class="form-radio h-5 w-5 text-blue-600" id="ingredient1" name="placement_type" v-model="viewDatalistData.placement_type" value="PLACEMENT_TYPE_AUTOMATIC" :disabled="editPageType">
            <RadioButton class="form-radio h-5 w-5 text-blue-600" inputId="ingredient1" name="placement_type" v-model="viewDatalistData.placement_type" value="PLACEMENT_TYPE_AUTOMATIC" :disabled="editPageType"/>
            <label for="ingredient1" class="ml-2">{{lang['components']['Event']['PositionAndDevice']['auto_position']}}</label>
          </div>
          <div class="flex">
            <input v-if="false" type="radio" class="form-radio h-5 w-5 text-blue-600" id="ingredient2" name="placement_type" v-model="viewDatalistData.placement_type" value="PLACEMENT_TYPE_NORMAL" :disabled="editPageType">
            <RadioButton class="form-radio h-5 w-5 text-blue-600" inputId="ingredient2" name="placement_type" v-model="viewDatalistData.placement_type" value="PLACEMENT_TYPE_NORMAL" :disabled="editPageType"/>
            <label for="ingredient2" class="ml-2">{{lang['components']['Event']['PositionAndDevice']['edit_position']}}</label>
          </div>

          <!-- <div class="flex pt-8">
            <div>
              <span class="text-red-500">*</span>
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['PositionAndDevice']['position_block_title']}}</span>
            </div>
          </div> -->
          <!-- <MultiSelect v-model="viewDatalistData.publisher_platforms" :options="viewDatalistData.publisher_platforms_list" optionLabel="name" optionValue="code" placeholder="請選擇"
            :filter="false" class="w-full lg:w-2/5 multiselect-custom" display="chip" :disabled="viewDatalistData.auto_publisher == true || editPageType">
          </MultiSelect> -->
          <!-- 新手教學 -->
          <MultiSelect ref="step47Click" id="teachingPAD" v-model="viewDatalistData.placements" :options="viewDatalistData.publisher_platforms_list" optionDisabled="disabled" optionLabel="name" optionValue="code" :placeholder="lang['components']['Event']['PositionAndDevice']['position_item_title_placeholder']"
            :filter="false" class="w-full lg:w-2/5 multiselect-custom" :disabled="viewDatalistData.placement_type == 'PLACEMENT_TYPE_AUTOMATIC' || editPageType" :class="{ 'ring-4 border-blue-400': guideStep === 47 }">
            <template #value="slotProps">
                <div class="country-item country-item-value" v-for="option of slotProps.value" :key="option.code">
                  <div>{{platFormLabel[option]}}</div>
                </div>
                <template v-if="!slotProps.value || slotProps.value.length === 0">
                    {{lang['components']['Event']['PositionAndDevice']['position_item_title_placeholder']}}
                </template>
            </template>
          </MultiSelect>
        </div>
        <!-- 新手教學 -->
        <div class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 49, 'cursor-not-allowed': editPageType === true }">
          <div>
            <!-- <span class="text-red-500">*</span> -->
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['PositionAndDevice']['device_block_title']}}</span>
            <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip="'關係鏈與受眾'"></i> -->
          </div>
          <Dropdown
            :disabled="editPageType" v-model="viewDatalistData.operating_systems" optionLabel="name" optionValue="code" :options="viewDatalistData.user_os_list" :placeholder="lang['components']['Event']['PositionAndDevice']['device_block_title_placeholder']" class="w-full lg:w-1/3 rounded-md"
          />
        </div>
      </div>

    </div>
    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar"></div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
  import RadioButton from 'primevue/radiobutton';
  import MultiSelect from 'primevue/multiselect';
  import Dropdown from 'primevue/dropdown';
  import InputSwitch from 'primevue/inputswitch';
  import Vue3DraggableResizable from 'vue3-draggable-resizable'
  import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'

  export default {
    name: 'PositionAndDevice',
    components: {
      RadioButton,
      MultiSelect,
      Dropdown,
      InputSwitch
    },
    props: {
      // <!-- 新手教學 -->
      guideStep: {
        type: Number,
        default: 1
      },
      // <!-- 新手教學 -->
      editPage: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      keywordViewDatalist: {
        type: Object
      },
      autoPublisher: {
        type: Boolean
      },
      publisherPlatforms: {
        type: Object
      },
      lang: {
        type: Object
      },
      keywordsSelectedList: {
        type: Object
      },
      youtubeClose: {
        type: Boolean
      }
    },
    data() {
      return {
        autoPublisherForm: false,
        testValue: ["mobile","desktop"],
        devicePlatformsList: [
          {
            name: "行動裝置",
            code: "mobile",
            disabled: false
          },
          {
            name: "桌上型電腦",
            code: "desktop",
            disabled: false
          }
        ],
        selectDeviceLabel: {mobile:"行動裝置", desktop:"桌上型電腦"},
        publisherPlatFormsDb: [],
        platFormLabel: {PLACEMENT_TIKTOK:"TikTok", PLACEMENT_GLOBAL_APP_BUNDLE:"Global App Bundle", PLACEMENT_PANGLE:"Pangle"},
        usAuto: true,
        selectedTags: [3, 7],
        tags: [
          {
            code: 1,
            text: '排除粉絲專頁',
            checked: false
          },
          {
            code: 2,
            text: '排除購買15天',
            checked: false
          },
          {
            code: 3,
            text: '排除購買30天',
            checked: true
          },
          {
            code: 4,
            text: '排除購買60天',
            checked: false
          },
          {
            code: 5,
            text: '排除RT30天',
            checked: true
          },
          {
            code: 6,
            text: '排除RT60天',
            checked: false
          },
          {
            code: 7,
            text: '預設選項',
            checked: false
          },
        ],
        x: 0,
        y: 0,
        h: 200,
        w: 320,
        active: false,
        src: "https://www.youtube.com/watch?v=3wGiBNSfa8E",
        vars: {
          rel: 0,
          start: 0,
          end: 0,
        },
        view_youtube: false,
        ingredient: 'PLACEMENT_TYPE_AUTOMATIC'
      }
    },
    watch: {
      // 'viewDatalistData.publisher_platforms'(value){
      //   console.log('viewDatalistData.publisher_platforms');
      //   console.log(value);
      //   let platformsLength = value.length;
      //   console.log(platformsLength);
      //   console.log(this.viewDatalistData.publisher_platforms);
      //   this.viewDatalistData.placements = value
      //   if(platformsLength == 4){
      //     this.autoPublisherForm = true;
      //     this.autoPublisherData = true;
      //   } else {
      //     this.autoPublisherForm = false;
      //     this.autoPublisherData = false;
      //   }
      // },
      // 'autoPublisherData'(value){
      //   console.log('autoPublisherData');
      //   console.log(value);
      //   console.log(typeof value);
      //   if(value){
      //     this.autoPublisherForm = true;
      //     this.viewDatalistData.publisher_platforms = ["facebook","instagram","audience_network","messenger"];
      //     this.viewDatalistData.placements = ["facebook","instagram","audience_network","messenger"];
      //   } else {
      //     this.autoPublisherForm = true;
      //     this.viewDatalistData.publisher_platforms = [];
      //     this.viewDatalistData.placements = [];
      //   }
      // },
      'lang':function(v){
        this.devicePlatformsList = [
          {
            name: this.lang['components']['Event']['PositionAndDevice']['device_mobile'],
            code: "mobile",
            disabled: false
          },
          {
            name: this.lang['components']['Event']['PositionAndDevice']['device_desktop'],
            code: "desktop",
            disabled: false
          }
        ];
        this.selectDeviceLabel = {mobile:this.lang['components']['Event']['PositionAndDevice']['device_mobile'], desktop:this.lang['components']['Event']['PositionAndDevice']['device_desktop']};
      },
      'viewDatalistData.device_platforms':function(v){
        // console.log('viewDatalistData.device_platforms');
        // console.log(v);

        // let devicePlatformsLength = v.length;

        // if(v[0] == "desktop" && devicePlatformsLength == 1){
        //   this.viewDatalistData.publisher_platforms_list = [
        //     {name: "Facebook", code: "facebook", disabled: true},
        //     {name: "Instagram", code: "instagram", disabled: true},
        //     {name: "Audience Network", code: "audience_network", disabled: true},
        //     {name: "Messenger", code: "messenger", disabled: true},
        //   ];
        //   this.viewDatalistData.placements = ["facebook"];
        // } else {
        //   this.viewDatalistData.publisher_platforms_list = [
        //     {name: "Facebook", code: "facebook", disabled: false},
        //     {name: "Instagram", code: "instagram", disabled: false},
        //     {name: "Audience Network", code: "audience_network", disabled: false},
        //     {name: "Messenger", code: "messenger", disabled: false},
        //   ];
        // }

        // if(devicePlatformsLength == 2){
        //   this.autoPublisherForm = true
        // } else {
        //   this.autoPublisherForm = false
        // }
      },
      'viewDatalistData.operating_systems': function(v){
        // console.log('viewDatalistData.operating_systems');
        // console.log(v);
      },
      'youtubeClose':function(v){
        // console.log('marketingmethod youtubeClose');
        // console.log(v);

        let _tmpYoutubeType = v.split('_');

        // console.log('_tmpYoutubeType');
        // console.log(_tmpYoutubeType);

        // console.log(typeof this.view_youtube);
        // console.log(this.view_youtube);

        if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
          if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'pad'){
            this.view_youtube = false
          }
        }

        // console.log(typeof this.view_youtube);
        // console.log(this.view_youtube);
      },
      guideStep(val) {
        // this.$refs.step47Click.show();
        // this.$refs.step47Click.overlayVisible = value === 47 ? true : false;
        if (val == 47) {
          // console.log(value);
          // this.$refs.step47Click.overlayVisible = true;
          // console.log(this.$refs.step47Click);
          // console.log(this.$refs.step47Click.overlayVisible);

          // this.$refs.step47Click.show();
          // document.getElementById("test").click();

          setTimeout(function(){
              // console.log("I am the third log after 1 seconds");
              document.getElementById("teachingPAD").click();
          },350);
        }
      },
      // 'publisherPlatformsData'(value){
      //   console.log('publisherPlatformsData');
      //   console.log(value);

      //   this.viewDatalistData.placements = value;

      //   console.log('this.viewDatalistData.placements');
      //   console.log(this.viewDatalistData.placements);
      // },
      // 'autoPublisherForm'(value){
      //   console.log('autoPublisherForm');
      //   console.log(value);

      //   this.viewDatalistData.auto_publisher = value;
      // },
      'viewDatalistData.placements'(value){
        // console.log('viewDatalistData.placements');
        // console.log(value);

        let _length = value.length;
        let _tiktok = 1;
        // console.log(_tiktok);

        for (let i = 0; i < _length; i++) {
          if(value.includes('PLACEMENT_TIKTOK') == false){
            // console.log('沒勾 tiktok');
            _tiktok = 0;
            break;
          }
        }

        // console.log('this.keywordsSelectedList');
        // console.log(this.keywordsSelectedList);

        // console.log(_tiktok);
        // console.log('b this.keywordViewDatalist');
        // console.log(this.keywordViewDatalist);

        let tiktok_status = 'false_0';

        if(_tiktok == 0){
          let _tmp_selectedCategories = {};

          Object.keys(this.keywordsSelectedList).forEach(key => {
            let _key_data = key.split('|');
            if(_key_data[1] == 'interest_categories'){
              _tmp_selectedCategories[key] = {checked: this.keywordsSelectedList[key].checked, partialChecked: this.keywordsSelectedList[key].partialChecked};
            }
          });

          // console.log('_tmp_selectedCategories');
          // console.log(_tmp_selectedCategories);

          this.keywordViewDatalist.creator_action_categories = [];
          this.keywordViewDatalist.interest_keywords = [];
          this.keywordViewDatalist.video_action_categories = [];
          this.keywordViewDatalist.hashtags = [];

          this.$emit('childReturnKeywords', _tmp_selectedCategories);

          var todayForm = new Date();
          var yearForm = todayForm.getFullYear();
          var dateForm = String(todayForm.getDate()).padStart(2, '0');
          var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
          var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

          todayForm = yearForm + monthForm + dateForm + timeForm;

          tiktok_status = 'true_'+todayForm;
        }

        this.$emit('childNoTiktok', tiktok_status);

        // console.log('a this.keywordViewDatalist');
        // console.log(this.keywordViewDatalist);
        // let platformsLength = value.length;

        // console.log('platformsLength');
        // console.log(platformsLength);

        // this.viewDatalistData.publisher_platforms = value;
        // this.viewDatalistData.placements = value;

        // if(platformsLength == 4){
        //   this.autoPublisherForm = true
        // } else {
        //   this.autoPublisherForm = false
        // }

        // console.log('this.viewDatalistData.publisher_platforms');
        // console.log(this.viewDatalistData.publisher_platforms);
      }
    },
    methods: {
      onReady() {
        // console.log('youtube');
        this.$refs.youtube.playVideo()
        // this.$refs.youtube.pauseVideo()
      },
      onStateChange(e){
        // console.log(e);

        if(e.data == 0){
          this.view_youtube = false
        }
      },
      teachVideo(){
        this.$emit('checkClose')
        // let elem = document.getElementById('marketingMethod');
        // let positio = this.getPosition(elem);
        // console.log('x:'+positio.x);
        // console.log('y:'+positio.y);

        // this.x = positio.x + parseInt(80);
        // this.y = positio.y

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;

        // console.log('windowWidth');
        // console.log(windowWidth);
        // console.log('windowHeight');
        // console.log(windowHeight);

        this.x = windowWidth - parseInt(390);
        this.y = windowHeight - parseInt(350);

        this.view_youtube = true;
        this.$emit('childYoutube', 'true_pad')

        this.vars.start = 0
        this.vars.end = 16
      },
      getPosition(element) {
        let x = 0;
        let y = 0;

        while ( element ) {
          x += element.offsetLeft - element.scrollLeft + element.clientLeft;
          y += element.offsetTop - element.scrollLeft + element.clientTop;
          element = element.offsetParent;
        }

        return { x: x, y: y };
      },
      print(val) {
        // console.log(val)
      },
      doDragging(){
        // console.log('doDragging');
      },
      testPAD() {
        // console.log('hello')
        this.$refs.step47Click.show();
        this.$refs.step47Click.overlayVisible = true;
        // console.log(this.$refs.step47Click);
      },
      selectAll (event) {
        // console.log(this.autoPublisherData)
        if(this.editPageType == false){
          if(!this.autoPublisherForm){
            this.autoPublisherForm = true;
            this.autoPublisherData = true;
            // this.viewDatalistData.publisher_platforms = ["facebook","instagram","audience_network","messenger"];
            // this.viewDatalistData.placements = ["facebook","instagram","audience_network","messenger"];
            // this.viewDatalistData.device_platforms = ["mobile","desktop"];
          } else {
            this.autoPublisherForm = false;
            this.autoPublisherData = false;
            // this.viewDatalistData.publisher_platforms = ["facebook"];
            // this.viewDatalistData.placements = ["facebook"];
            // this.viewDatalistData.device_platforms = ["desktop"];
          }
        }

        // if (!this.isSelect) {
        //   console.log('is checked');
        //   this.list.map(function(value, key) {
        //     console.log('value:'+value.name)
        //     if(value.status == 1){
        //       value.status = 2;
        //     }
        //   });
        // } else {
        //   console.log('un checked');
        // }
      }
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      },
      autoPublisherData: {
        get: function () {
          return this.autoPublisher
        },
        set: function (value) {
          this.$emit('update:autoPublisherData', value)
        },
      },
      publisherPlatformsData: {
        get: function () {
          return this.publisherPlatforms
        },
        set: function (value) {
          this.$emit('update:publisherPlatformsData', value)
        },
      },
    },
  }
</script>
<style lang="scss" scoped>
  /*::v-deep(.multiselect-custom) {
    .p-multiselect-token {
      font-size: .875rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      border-radius: 0.25rem;
      display: inline-flex;
      margin: 0.25rem;
      --tw-bg-opacity: 1;
      background-color: rgba(96, 165, 250, var(--tw-bg-opacity));
      --tw-text-opacity: 1;
      color: rgba(255, 255, 255, var(--tw-text-opacity));
    }
  }*/

  ::v-deep(.multiselect-custom) {
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: .25rem;
        padding-bottom: .25rem;
    }

    .country-item-value {
        padding: .25rem .5rem;
        border-radius: 3px;
        display: inline-flex;
        margin-right: .5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);

        img.flag {
            width: 17px;
        }
    }
  }
</style>
<style type="text/css">
  .multiselect-custom .p-multiselect-label-container .p-multiselect-label .country-item-value {
    padding: 0.25rem 0.5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: #111827;
    color: #fff;
  }
</style>